<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    data-name="Layer 1"
    viewBox="0 0 949.8 661.52"
  >
    <defs />
    <defs>
      <path
        id="g"
        class="fill-current text-primary"
        d="M611.52 398.64c0 6.06-11 23.63-11 23.63s-11-17.57-11-23.63a11 11 0 0121.94 0zm18.14 33.56c-3.29 5.09-22.05 13.87-22.05 13.87s.34-20.71 3.63-25.8a11 11 0 1118.42 11.93zm-.76 57.37c-5.41 2.73-26 .84-26 .84s10.75-17.71 16.16-20.44a11 11 0 119.84 19.6zm-10.41 43.26c-4.87 3.6-25.53 5.23-25.53 5.23s7.6-19.27 12.48-22.88a11 11 0 0113 17.64zm-33.93-85.58c4.35 4.22 24.6 8.6 24.6 8.6s-5-20.11-9.31-24.34a11 11 0 10-15.29 15.74zm-11.49 50.76c5.41 2.73 26 .84 26 .84s-10.75-17.71-16.16-20.44a11 11 0 00-9.88 19.59zm-4.39 50.86c4.87 3.6 25.53 5.23 25.53 5.23s-7.6-19.27-12.48-22.88a11 11 0 00-13 17.64z"
      />
      <path
        id="f"
        class="fill-current text-primary"
        d="M316.9 397.94c0 6.06-11 23.63-11 23.63s-11-17.57-11-23.63a11 11 0 1121.94 0zm18.11 33.56c-3.29 5.09-22.05 13.87-22.05 13.87s.34-20.71 3.63-25.8a11 11 0 1118.42 11.93zm-.79 57.37c-5.41 2.73-26 .84-26 .84s10.75-17.71 16.16-20.44a11 11 0 119.88 19.59zm-10.37 43.26c-4.87 3.6-25.53 5.23-25.53 5.23s7.6-19.27 12.48-22.88a11 11 0 0113 17.64zm-33.95-85.58c4.35 4.22 24.6 8.6 24.6 8.6s-5-20.11-9.31-24.34a11 11 0 10-15.29 15.74zm-11.47 50.76c5.41 2.73 26 .84 26 .84s-10.71-17.71-16.12-20.39a11 11 0 00-9.88 19.59zm-4.4 50.86c4.87 3.6 25.53 5.23 25.53 5.23s-7.6-19.27-12.48-22.88a11 11 0 10-13 17.64z"
      />
      <path
        id="d"
        d="M175.03 381.08l-.9 4.89a38 38 0 01-8.06-.41l-28.51.41c-1.35-.08-2.61-.19-3.79-.31a26 26 0 00-6.39-2.95z"
        opacity=".1"
      />
    </defs>
    <defs>
      <linearGradient
        id="a"
        x1="585.6"
        x2="585.6"
        y1="663"
        y2="249"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stop-color="gray"
          stop-opacity=".25"
        />
        <stop
          offset=".54"
          stop-color="gray"
          stop-opacity=".12"
        />
        <stop
          offset="1"
          stop-color="gray"
          stop-opacity=".1"
        />
      </linearGradient>
      <linearGradient
        id="b"
        x1="266.19"
        x2="266.19"
        y1="487.11"
        y2="486.89"
        xlink:href="#a"
      />
      <linearGradient
        id="c"
        x1="252.55"
        x2="252.55"
        y1="605"
        y2="271"
        xlink:href="#a"
      />
      <linearGradient
        id="e"
        x1="852.66"
        x2="852.66"
        y1="602"
        y2="195"
        xlink:href="#a"
      />
    </defs>
    <circle
      cx="95.13"
      cy="66.03"
      r="46.49"
      class="fill-current text-primary"
    />
    <path
      class="fill-current text-primary"
      d="M89.45 160.67c19.52 44.09-5.38 94.86-34.69 133.09-9.81 12.82-20.64 26.26-22 42.34-1.64 19.67 11.68 37.75 27.48 49.57 28.82 21.54 68.18 28.2 102.48 17.33 29.64-9.39 54.56-30.6 84.46-39.15 50-14.32 103 9.42 145.82 39 30.31 20.91 62.77 46.39 99.31 41.91 25.71-3.15 47.53-21.2 62.34-42.45 7.15-10.26 13.37-21.76 23.78-28.68 6.19-4.12 13.46-6.3 20.73-7.86 66.39-14.19 136.85 20.44 202.36 2.63 44.25-12 79.53-47 101.47-87.27s32.18-85.74 40.71-130.79c6.06-32 11.09-66.57-2.84-96C926.12 23.18 892 4.29 857.71.75s-68.68 6.23-100.27 20.01c-39.47 17.26-78.16 41.42-121.24 41.5-29.34.06-57.32-11.2-85.37-19.79-46.9-14.35-95.67-21.48-144.27-28.06-46.53-6.3-93.52-12.16-140.33-8.44-33.12 2.63-62.37 15.29-94.51 21.15-20.95 3.82-42 1-62.56 7.4C83.84 42.44 57.8 60.79 56.4 89.69c-1.32 27.51 22.7 47.59 33.05 70.98z"
      opacity=".1"
    />
    <path
      fill="url(#a)"
      d="M727 319.17c-4.27-11.13-15.28-37.29-22.53-32.1-9.16 6.56 9.16 35.54 9.16 35.54.52 5.32-9.78 16.39-15.3 21.91v-.69a2.4 2.4 0 01-.24.6l-.46-.25a3 3 0 01-.65 1.19c0-.75-.05-1.19-.05-1.19-1.06 4.49-19.56 10.18-19.56 10.18h-1.36c-5.14 0-18.52-1.16-24.72-11.08a54.86 54.86 0 00-12.13-14.15 10.33 10.33 0 00-5.75-2.18c-17.13-1.1-31-9.77-33.77-11.62l-.51-.35-.11.32c-.65-.93-1.28-1.92-1.87-2.94l-.3-.55a25.12 25.12 0 0013.85-22.34v-.52a17.11 17.11 0 002.3-8.57v-3l3.91-3.48c1.79-1.59 3.64-3.27 4.55-5.46a6.47 6.47 0 00.48-2.8 4.85 4.85 0 00-1.84-4.34c-3-2.07-8 0-10.17-2.88-1-1.3-.82-3.07-1.31-4.6-1-3.11-4.6-4.79-7.93-4.84s-6.52 1.16-9.72 2.07a57.07 57.07 0 01-20.7 1.94 13.52 13.52 0 00-5.67.2 7.81 7.81 0 00-4.6 5.35 12.57 12.57 0 00-.44 2.74 17.24 17.24 0 00-4.34 11.41v7.69a17.23 17.23 0 004.15 11.19 25 25 0 0010.47 18.24v.61l.13.08a41.35 41.35 0 01-1.1 7.07v-.51s-14 7.45-29 7.63h-1.65a11.17 11.17 0 00-8 3c-4.44 4.18-12.22 10.79-17 10.79-1 0-26.24 4.93-30.42 5.75l-7.81-7.65-.24.45-.46-.45a19 19 0 00-2.54.37c-4-4.74-12-15.76-13.85-30.55 0 0 17.27-19.67 10.92-38-5.42-15.62-20.35 17.86-24.59 27.95a8.06 8.06 0 00-.26 5.55L458 347.12a21.21 21.21 0 00-1.11 11h-.16l10.22 13.11s7.69 3.28 19.72 3.22a68.94 68.94 0 0025.74-4.94h2.37l-.45.17h12.17l7.74 23.41c-.26 2.13-4 31.86-7 38.51a16.71 16.71 0 00-1.18 7 53.44 53.44 0 002.23 13.55l6.78-.25-.26.53c-5.74 11.77-15.33 32.74-21 52.34l-9.87 20 7.4 89.7h.3l.57.09c.8.12 2 .3 3.58.5l-.58 1-16.31 27s-11.63 23.81 14.1 19.32c0 0 9.51-2.76 13.39-19l16.92-15.87s.79-10.54-4-14.75c-.3-4.87-1.06-19.09.11-22.51 1.41-4.14-6-51.75-6-51.75s26.78-55.55 43-56.93a8.89 8.89 0 013.51.46c13.33 4.34 29.48 36.57 34.23 46.6l.22.46v.09l.18.39v.11l.16.34v.09l.14.31v.07l.12.25v.1l.09.19v.08l.06.14v.17l.05.12 2.11 62.45.21.11h.1l-.18 1.29-.92 6.45s11.63 24.5 10.92 27.6 7.75 15.53 19.73 12.08 4.85-22.9 4.85-22.9l-11.54-23.78-.51-1.06a22.68 22.68 0 003.24-2.41s-3.52-25.53 0-31.05 4.58-30.71 4.58-30.71-2.47-17.25-6.7-24.84l-17.72-63.25c5.31 4.94 9.44 6.87 12.89 6.74h.57a8.61 8.61 0 004.34-1.08 12.23 12.23 0 002-1.41 3.16 3.16 0 00.33-.33c4.93-4.14-5.64-20.36-11.63-30-5.77-9.3 2.18-34.57 2.78-36.45a9.54 9.54 0 011.71-1 10.55 10.55 0 013.92-.85c5.74.2 12.8 3.5 21.54 5.16a101.62 101.62 0 0018.39 1.43h.36c2.45 0 4.67-.05 6.47-.12a10.93 10.93 0 004.7-1.27 14.19 14.19 0 003.34-2.7l15.34-17.33-.4.19a8.62 8.62 0 000-6.1l16.21-28a10.65 10.65 0 00.79-9.23z"
      transform="translate(-125.1 -119.24)"
    />
    <path
      fill="#444176"
      d="M419.78 505.9l-16.33 15.65c-3.74 16-12.93 18.71-12.93 18.71-24.83 4.42-13.61-19-13.61-19l15.75-26.65 1.94-3.29s11.23-3.4 18.71-1.36a6.4 6.4 0 012.55 1.38c4.69 4.07 3.92 14.56 3.92 14.56zm100.69 13.95c-11.57 3.4-19.73-8.84-19-11.91s-10.57-27.18-10.57-27.18l.88-6.36.82-5.89 19 1.36 1.79 3.76 11.14 23.45s7.51 19.37-4.06 22.77z"
    />
    <path
      d="M416.04 494c-1.79 3.07-16.3 1.52-23.37.56l1.94-3.29s11.23-3.4 18.71-1.36a6.4 6.4 0 012.55 1.38c.1 1.66.17 2.71.17 2.71zm97.37-20.39c-9.73 6.48-20.09 1.58-21.65.77l.82-5.89 19 1.36z"
      opacity=".1"
    />
    <path
      fill="#565387"
      d="M516.05 439.57c-3.4 5.44 0 30.62 0 30.62-11.23 10.21-24.49 2.72-24.49 2.72l-2-61.57s-22.11-50.69-37.76-49.33-41.5 56.13-41.5 56.13 7.14 46.94 5.78 51 0 23.81 0 23.81c-2.38 4.08-27.21 0-27.21 0l-7.14-88.45 9.48-19.74c5.45-19.32 14.71-40 20.25-51.6 2.75-5.77 4.59-9.29 4.59-9.29l18.1-3.77 58.75-12.18 21.11 76.84c4.08 7.48 6.46 24.49 6.46 24.49s-1.02 24.88-4.42 30.32z"
    />
    <g opacity=".1">
      <path d="M497 472.91l-2-61.57s-22.11-50.69-37.76-49.33a8.52 8.52 0 00-2.05.46c15.26 5.07 34.37 48.87 34.37 48.87l2 61.57a24 24 0 0013.53 2.47 24.07 24.07 0 01-8.09-2.47z" />
      <path d="M394.27 492.98l-7.14-88.45 9.52-19.77c5.45-19.32 14.71-40 20.25-51.6 2.75-5.77 4.59-9.29 4.59-9.29l18.1-3.77 53.63-11.15-.29-1.07-58.78 12.22-18.1 3.77s-1.84 3.52-4.59 9.29c-5.56 11.6-14.8 32.32-20.25 51.6l-9.52 19.73 7.14 88.45s13.56 2.23 21.6 1.74a160.66 160.66 0 01-16.16-1.7z" />
    </g>
    <path
      fill="#ced2df"
      d="M352.9 218.97s-19.39 1-16.67 21.43l5.44.68 8.16-8.84 4.08-7.48v-1.7z"
    />
    <path
      d="M352.9 218.97s-19.39 1-16.67 21.43l5.44.68 8.16-8.84 4.08-7.48v-1.7z"
      opacity=".1"
    />
    <path
      fill="#ced2df"
      d="M568.61 226.45s16 8.5 11.91 18.37l-5.1 2-6.8-3.74-1-8.84.68-6.12z"
    />
    <path
      d="M568.61 226.45s16 8.5 11.91 18.37l-5.1 2-6.8-3.74-1-8.84.68-6.12z"
      opacity=".1"
    />
    <rect
      width="55.79"
      height="42.18"
      x="431.18"
      y="138.68"
      fill="#88455e"
      rx="21.09"
      ry="21.09"
    />
    <path
      fill="#ec8c9c"
      d="M352.77 221.86l-11.91 19-1-3.38-16.18-52.72a8.11 8.11 0 01.25-5.47c4.09-9.94 18.51-43 23.74-27.55 6.12 18-10.55 37.42-10.55 37.42 1.9 15.76 10.75 27.18 14.23 31.14.88 1.03 1.42 1.56 1.42 1.56zm213.29 8.16s18.71-17.69 18-24.83c0 0-17.69-28.57-8.84-35 7-5.12 17.63 20.68 21.75 31.65a10.7 10.7 0 01-.71 9l-22.36 39.59zM444.95 180.7s3.4 21.77-6.46 29.94 28.24 8.12 28.24 8.12l13.61-12.59s-15.65-14.63-10.89-25.51z"
    />
    <path
      d="M444.27 205.53s14.63 10.89 29.25-1.36l23.81 49.33-1.36 60.21s-49.33 25.51-69.74 9.87-3.4-23.81-3.4-23.81l-4.76-46.26 5.1-29.94s9.18-14.29 9.87-14.29 11.23-3.75 11.23-3.75z"
      opacity=".1"
    />
    <path
      fill="#ebf1f6"
      d="M444.27 204.85s14.63 10.91 29.26-1.36l23.81 49.33-1.36 60.21s-49.33 25.51-69.74 9.87-3.4-23.81-3.4-23.81l-4.76-46.26 5.1-29.94s9.18-14.29 9.87-14.29 11.22-3.75 11.22-3.75z"
    />
    <path
      d="M444.27 199.76s-13.87 7.9-28.93 7.51a10.66 10.66 0 00-7.69 2.94c-4.29 4.12-11.8 10.64-16.45 10.64-1 0-29.94 5.78-29.94 5.78l-7.65-7.65s-11.4 22.28-16.84 21.26l9.87 12.93s18.71 8.16 43.2-1.7h14.29l7.48 23.13s-3.74 31.3-6.8 38.1 1 20.07 1 20.07l26.87-1s1.36-13.27 3.4-15-7.14-60.21-7.14-60.21-6.12-33 16.33-44.9z"
      opacity=".1"
    />
    <path
      d="M434.14 320.14a88.81 88.81 0 00-2.11 12.27l-20.57.78c2.75-5.77 4.59-9.29 4.59-9.29zm-81.37-98.28l-11.91 19-1-3.38c4.37-4.34 9.49-13.41 11.53-17.19.84 1.04 1.38 1.57 1.38 1.57z"
      opacity=".1"
    />
    <path
      fill="#ced2df"
      d="M444.27 199.76s-14.56 7.9-29.61 7.51a10.66 10.66 0 00-7.69 2.94c-4.29 4.12-11.8 10.64-16.45 10.64-1 0-29.94 5.78-29.94 5.78l-7.68-7.66s-11.4 22.28-16.84 21.26l9.87 12.93s18.71 8.16 43.2-1.7h14.29l7.48 23.12s-3.74 31.3-6.8 38.1 1 20.07 1 20.07l26.87-1s1.36-13.27 3.4-15-7.14-60.21-7.14-60.21-6.12-33 16.33-44.9z"
    />
    <path
      d="M473.53 197.7s13.88 10.58 32.41 11.8a9.85 9.85 0 015.55 2.15 53.72 53.72 0 0111.71 14c7.48 12.25 25.85 10.89 25.85 10.89s17.86-5.61 18.88-10c0 0 .51 24 11.74 18.2l-14.77 17.02a10.42 10.42 0 01-7.45 3.59c-5.55.22-15.19.29-23.33-1.29-12.25-2.38-21.09-8.16-27.55-3.06 0 0-8.5 26.53-2.72 36.06s16 25.51 11.23 29.6-10.55 3.74-20.07-6.12-10.55-26.53-10.55-26.53l2.38-42.86s-9.18-32.32-18-38.78z"
      opacity=".1"
    />
    <path
      d="M581.02 244.31l-14.81 17.09a10.41 10.41 0 01-3.57 2.66 10.37 10.37 0 01-3.86.91c-5.55.23-15.19.3-23.33-1.29-11.46-2.23-19.94-7.43-26.28-3.92a9.3 9.3 0 00-1.28.85s-8.5 26.53-2.72 36.06 16 25.51 11.23 29.6a11 11 0 01-2.66 1.73c-4.28 1.93-9.59.26-17.41-7.85-9.52-9.87-10.55-26.53-10.55-26.53l2.38-42.86s-9.18-32.32-18-38.78l3.89-13.95c2.68 1.82 16.06 10.37 32.6 11.46a9.85 9.85 0 015.55 2.15 53.76 53.76 0 0111.71 14c7.48 12.25 25.85 10.89 25.85 10.89a99.27 99.27 0 0012.87-5.12c2.61-1.28 4.91-2.68 6-4a3 3 0 00.65-1.2s.52 23.88 11.74 18.1z"
      opacity=".1"
    />
    <path
      fill="#ced2df"
      d="M580.34 244.65l-14.8 17.11a10.41 10.41 0 01-2.88 2.32 10.38 10.38 0 01-4.54 1.25c-5.55.23-15.19.3-23.33-1.29-11.05-2.15-19.34-7.07-25.59-4.26a9.25 9.25 0 00-2 1.19s-8.5 26.53-2.72 36.06 16 25.51 11.23 29.6a11.8 11.8 0 01-2 1.39c-4.4 2.43-9.84 1-18.09-7.51-9.52-9.87-10.55-26.53-10.55-26.53l2.38-42.86s-9.18-32.32-18-38.78l4.08-14.63.49.34c2.68 1.82 16.06 10.37 32.6 11.46a9.85 9.85 0 015.55 2.15 53.76 53.76 0 0111.71 14c7.48 12.25 25.85 10.89 25.85 10.89a99.27 99.27 0 0012.87-5.12c3.09-1.58 5.61-3.31 6-4.89v.86c.3 4.13 1.8 22.36 11.74 17.25z"
    />
    <path
      d="M469.75 181.21h-25a61.18 61.18 0 01.47 12 25.7 25.7 0 0026.42 1.9c-2.4-4.44-3.86-9.48-1.89-13.9z"
      opacity=".1"
    />
    <circle
      cx="459.92"
      cy="172.53"
      r="24.83"
      fill="#ec8c9c"
    />
    <path
      d="M454.76 168.11c2.77-.33 5.54-1.31 8.27-.76 2.48.5 4.59 2.21 7.07 2.73 4.78 1 9.22-2.52 12.83-5.8l7.8-7.1c1.73-1.57 3.51-3.22 4.4-5.38s.58-5-1.32-6.36c-2.85-2-7.76 0-9.82-2.84-.93-1.28-.79-3-1.27-4.53-1-3.06-4.44-4.73-7.66-4.77s-6.3 1.14-9.38 2a54 54 0 01-20 1.91 12.78 12.78 0 00-5.47.19 7.65 7.65 0 00-4.44 5.27c-1.54 5.44 1.09 14.21 3.73 19.08s9.99 7.01 15.26 6.36z"
      opacity=".1"
    />
    <path
      fill="#88455e"
      d="M454.76 167.43c2.77-.33 5.54-1.31 8.27-.76 2.48.5 4.59 2.21 7.07 2.73 4.78 1 9.22-2.52 12.83-5.8l7.8-7.1c1.73-1.57 3.51-3.22 4.4-5.38s.58-5-1.32-6.36c-2.85-2-7.76 0-9.82-2.84-.93-1.28-.79-3-1.27-4.53-1-3.06-4.44-4.73-7.66-4.77s-6.3 1.14-9.38 2a54 54 0 01-20 1.91 12.78 12.78 0 00-5.47.19 7.65 7.65 0 00-4.44 5.27c-1.54 5.44 1.09 14.21 3.73 19.08s9.99 6.96 15.26 6.36z"
    />
    <path
      d="M411.45 274.76s5.44.68 8.16 4.08 7.48 4.42 7.48 4.42m-64.63-53.41s4.44 9.91 1.7 10.91-1.7 8.16-1.7 8.16"
      opacity=".1"
    />
    <path
      d="M363.99 226.45s28.91-5.78 29.91-5.78c4.66 0 12.16-6.52 16.45-10.64a10.5 10.5 0 014.66-2.59h-.37a10.66 10.66 0 00-7.69 2.94c-4.29 4.12-11.8 10.64-16.45 10.64-.81 0-19.31 3.67-26.82 5.16zm80.32-25.26v-1.27a72.18 72.18 0 01-22.16 7.09 68.48 68.48 0 0022.16-5.82zm-35.75 131.39s-4.08-13.27-1-20.07 6.8-38.1 6.8-38.1l-7.46-23.13h-14.33l-.87.34h11.75l7.45 23.14s-3.74 31.3-6.8 38.1 1 20.07 1 20.07l26.87-1v-.21zM516.05 321.19a11.8 11.8 0 01-2 1.39c-4.4 2.43-9.84 1-18.09-7.51-7.56-7.83-9.76-20-10.35-24.61l-.2 3.52s1 16.67 10.55 26.53c8.25 8.54 13.69 9.94 18.09 7.51a11.8 11.8 0 002-1.39c1.43-1.23 1.51-3.54.76-6.42a3.15 3.15 0 01-.76.98zm59.48-76.03l-9.63 11.13a10.41 10.41 0 01-2.88 2.32 10.38 10.38 0 01-4.54 1.25c-5.55.23-15.19.3-23.33-1.29-11.05-2.15-19.34-7.07-25.59-4.26a9.25 9.25 0 00-2 1.19s-5.49 17.14-4.65 28.81c.65-10.91 4.65-23.37 4.65-23.37a9.25 9.25 0 012-1.19c6.26-2.81 14.54 2.11 25.59 4.26 8.14 1.58 17.77 1.51 23.33 1.29a10.38 10.38 0 004.54-1.25 10.41 10.41 0 002.88-2.29l14.81-17.09a5.83 5.83 0 01-5.18.49z"
      opacity=".1"
    />
    <path
      fill="url(#b)"
      d="M265.74 486.89a.77.77 0 00.91.12 3.1 3.1 0 01-.91-.12z"
      transform="translate(-125.1 -119.24)"
    />
    <path
      fill="url(#c)"
      d="M367.65 321.24c-1.8-.52-4.37-1.37-7.46-2.45a39.12 39.12 0 006.91-13.92l-.26.1c.09-.31.18-.61.26-.93-5.93 2.41-12.49-1.67-16.67-6.91s-7-11.74-11.58-16.56a53 53 0 00-6.14-5.29c-1.35-1-2.8-2.13-4.45-2.18-2.67-.08-4.76 2.54-7.33 3.31a10 10 0 01-5.11-.19c-6.63-1.52-13-4.33-19.77-5.07a23.17 23.17 0 00-10.73 1.21c-3.4 1.29-4.95 3.86-7.7 5.92-3 2.21-8.86 2.16-12.35 2.55a88.5 88.5 0 01-12.76.53 29.87 29.87 0 00-7.34.27c-5.07 1.11-9.14 5.14-12.94 9a6.67 6.67 0 00-2.14 3.35 4.23 4.23 0 000 1.11 7.21 7.21 0 00.51 2.95 39 39 0 004.91 9.77c1.55 2.22 3.36 4.31 4.24 6.94a13.47 13.47 0 01.65 4 29.09 29.09 0 01-.45 4.3 54 54 0 01-3.29 11.45 20.8 20.8 0 00-1.92 6 9.56 9.56 0 000 1.28c-.25 6.6 6.41 11.35 7.7 17.91a10.7 10.7 0 01.19 1.65c-.14 4.09-2.47 8.09-5.91 9.68.3.12.61.22.92.32a8.34 8.34 0 01-.92.5c.63.24 1.27.45 1.92.62a44.6 44.6 0 00-9.71 12C217.36 406 139 448.19 139 448.19l1.16.66-.94.61c-6.78 4.51-22.69 17.66-8.31 34.29 0 0 11.23-17.72 19.1-25.27.35-.34.7-.65 1-.94a2.3 2.3 0 01.3 1.82l51.52-28.95s18.31-12.82 23.42-15.71a42.15 42.15 0 0111.61-5l-.6.25a23.52 23.52 0 015.91-.84c9.12.14 19 6.82 22.25 33.27 4.36 35.42 2.34 41.81.94 42.68a2.57 2.57 0 01-.51-.09.87.87 0 00.14.1 2.68 2.68 0 01-.56-.1.8.8 0 00.76.18.71.71 0 00.57-.07 5.92 5.92 0 00.69 0q0 .49-.07 1c-.07 0-.41.19 0 .21-.11 2-.1 4.17 0 6.44-4.53.25-9.06.52-13 .76l.35-1.87.16-.84c3.48-.28 6.78-1.3 7.17-4.12.85-6.2-7.66-9.51-14.9-9.92s-50.66 2.48-50.66 2.48-6.51 8.43 14.14 11q.92.48 1.91 1c8.09 4.61 19.06 13.1 24.32 17.28l.73.58-2.36 1.92c12.77 2.89 25.12 51.69 31.93 74s21.71 21.5 34.06 18.19c11.57-3.1 13-36.7 13.19-40.92v-.43L335 587.26l1.56 1.93q.9.47 1.78.88c15.58 7.41 32.79-6.8 27.9-23-4.95-16.33-12.63-40.48-17.75-50.69-4.29-8.55-9.83-22.75-13.19-31.64a10.68 10.68 0 001.27-.61s-.08-.4-.21-1.13l.21-.11s-5-25.72-5.22-44V437.3c3.72-.85 6.08-1.18 6.08-1.18l.07-.8-.43.09 2.07-23.69s7.6-16.17 1.78-22.9a14.14 14.14 0 01-3.41-7c-1-6.19 0-16.52 13.55-25.1 20.86-13.23 29-24 29-24s.36-7.72-12.41-11.48zm-41.43 16.44v-10.95c3.87-.19 7.82.26 11.71 0a29.63 29.63 0 005.65-.95l.94.65a103 103 0 01-18.3 11.25zm-59.15 171.64c1.53 1.06 3.07 2.16 4.58 3.27.94 5.4 1.77 9.21 1.83 9.48a74.86 74.86 0 00-6.41-12.75z"
      transform="translate(-125.1 -119.24)"
    />
    <path
      fill="#ffbdc6"
      d="M175.03 381.08l-.9 4.89-.69 3.74-1.26 6.84-12.22 8.55s-1.1-.94-2.92-2.43c-5-4.12-15.53-12.48-23.26-17a26 26 0 00-6.39-2.95z"
    />
    <use
      opacity=".1"
      xlink:href="#d"
    />
    <path
      fill="#7679b4"
      d="M166.07 384.76s14.26 2.44 15.07-3.67-7.33-9.33-14.24-9.79-48.48 2.46-48.48 2.46-7.33 9.77 19.14 11.4z"
    />
    <path
      d="M175.03 381.08l-.9 4.89-.69 3.74-1.26 6.84-12.22 8.55s-1.1-.94-2.92-2.43c-5-4.12-15.53-12.48-23.26-17a26 26 0 00-6.39-2.95z"
      opacity=".1"
    />
    <use
      opacity=".1"
      xlink:href="#d"
    />
    <path
      d="M166.07 384.76s14.26 2.44 15.07-3.67-7.33-9.33-14.24-9.79-48.48 2.46-48.48 2.46-7.33 9.77 19.14 11.4z"
      opacity=".1"
    />
    <path
      fill="#a66477"
      d="M122.69 183.95h74.53v88.38h-74.53z"
    />
    <path
      d="M122.69 183.95h74.53v88.38h-74.53z"
      opacity=".1"
    />
    <path
      fill="#ffbdc6"
      d="M35.33 335.26c-1.23.31-2.79 1.49-4.54 3.21-7.53 7.44-18.27 24.89-18.27 24.89-13.76-16.38 1.47-29.33 8-33.78 1.58-1.08 2.64-1.66 2.64-1.66zm138.89-123.41s3.67 25.66 16.29 31.77-16.29 17.51-16.29 17.51l-39.51-14.66s22.4-7.33 17.92-28.92zM131.9 366.21l-.9 4.89-.69 3.74-1.26 6.84-12.22 8.55s-1.1-.94-2.92-2.43c-5-4.12-15.53-12.48-23.26-17a26 26 0 00-6.39-2.95z"
    />
    <path
      d="M131.9 366.21l-.9 4.89a38 38 0 01-8.06-.41l-28.51.41c-1.35-.08-2.61-.19-3.79-.31a26 26 0 00-6.39-2.95z"
      opacity=".1"
    />
    <path
      fill="#7679b4"
      d="M122.9 369.88s14.26 2.44 15.07-3.67-7.33-9.37-14.26-9.77-48.47 2.44-48.47 2.44-7.33 9.77 19.14 11.4z"
    />
    <path
      d="M130.27 374.85l-1.26 6.84-12.22 8.55s-1.1-.94-2.92-2.43l16.16-13.25z"
      opacity=".1"
    />
    <path
      fill="#7679b4"
      d="M210.9 468.09q-.84-.41-1.7-.87l-1.49-1.9-19.68-25v.44c-.13 4.15-1.55 37.25-12.61 40.3-11.81 3.26-26.07 4.07-32.58-17.92s-18.33-70.05-30.55-72.9l18.12-14.87s12 14 16.9 27.48c-.18-.86-8.47-39.57-1.63-46.41h59.46s9.16 26.14 15.48 39.1c4.9 10.06 12.25 33.84 17 49.93 4.7 15.92-11.72 29.92-26.72 22.62z"
    />
    <path
      d="M209.24 363.76c-9.17 5.43-49.49 3.22-62.63 2.34l-3.57-.26c-.39 0 .06-.22.06-.22l.37-3.7 9.77-24.84 52.34-30.32c-1.06 3.19-1.42 8.08-1.33 13.69.26 17.98 4.99 43.31 4.99 43.31z"
      opacity=".1"
    />
    <path
      fill="#f2f1f2"
      d="M209.24 362.55c-9.17 5.43-49.49 3.22-62.63 2.34l-3.57-.26h-.59l.65-.17 3.22-.85 6.92-27.7 52.34-30.34c-1.06 3.19-1.42 8.08-1.33 13.69.26 17.95 4.99 43.29 4.99 43.29z"
    />
    <path
      d="M204.25 319.22c-10.64 2.45-34.06 9.66-43.06 27-6 11.58-11 16.55-14.57 18.63l-3.57-.26.06-.22 3.22-.85 6.92-27.7 52.34-30.34c-1.08 3.28-1.43 8.13-1.34 13.74zm-181.14 8.71l12.22 7.33c-1.23.31-2.79 1.49-4.54 3.21-1-3-7.42-7.12-10.32-8.88 1.58-1.08 2.64-1.66 2.64-1.66zM140.9 365.1a.73.73 0 01-.86-.11 2.94 2.94 0 00.86.11z"
      opacity=".1"
    />
    <path
      fill="#565388"
      d="M168.51 241.99s-11 1.22-18.74-6.92c0 0-32.58 9.37-43.58 30.55s-85.94 62.72-85.94 62.72 13 7.33 11.81 11l49.28-28.51s17.51-12.63 22.4-15.48 31.77-20.36 37.47 27.29 0 42 0 42 8.15 2.85 20-20 48.47-28.1 48.47-28.1l2-24s7.27-15.92 1.7-22.56a14.1 14.1 0 01-3.26-6.89c-.93-6.1 0-16.27 13-24.72 20-13 27.7-23.62 27.7-23.62s.41-7.74-11.81-11.4-61.91-23.62-61.91-23.62l-1.63 6.92 39.1 27.7s-19.55 15.88-35 15.48c-.06-.07 2.79 11.75-11.06 12.16z"
    />
    <path
      d="M176.06 223.02a80 80 0 01-2.25-10l-21.59 5.74a23.8 23.8 0 01-.49 12.45 23.22 23.22 0 0024.33-8.2z"
      opacity=".1"
    />
    <circle
      cx="158.13"
      cy="207.57"
      r="23.22"
      fill="#ffbdc6"
    />
    <path
      d="M170.47 154.76c6.44.73 12.57 3.5 18.91 5a9.34 9.34 0 004.89.19c2.46-.76 4.46-3.34 7-3.26 1.57 0 3 1.12 4.26 2.15a51.11 51.11 0 015.87 5.21c4.37 4.75 7.09 11.15 11.08 16.31s10.28 9.18 15.95 6.81c-3.85 15-16.49 26.47-30.15 27.4-5.45.37-11-.76-16.31.84a14.28 14.28 0 01-4.12 1c-3 0-5.48-2.79-7.38-5.5-4.44-6.38-8-13.62-13-19.43-1.65-1.92-3.6-3.75-5.93-4.1s-4.48.76-6.56 1.84c-3.43 1.78-6.94 3.62-9.6 6.66s-4.34 7.59-3.24 11.71c.59 2.22 1.95 4.22 2 6.55 0 3.7-3.22 6.41-3.87 10a38.6 38.6 0 00-.16 4.56c-.29 4.94-3.51 9-6.89 12.09-1.31 1.21-2.77 2.5-3.15 4.37-.26 1.27 0 2.62-.17 3.91-.49 3.21-3.69 4.83-6.52 5.25a18.9 18.9 0 01-9.78-1.16c4-1.87 6.39-7.2 5.47-12-1.26-6.61-7.9-11.35-7.34-18.09a20.93 20.93 0 011.84-5.95 54.45 54.45 0 003.14-11.28 19.11 19.11 0 00-.19-9c-.85-2.59-2.58-4.65-4.06-6.84a38.82 38.82 0 01-4.7-9.63 6.75 6.75 0 01-.45-3.18 6.59 6.59 0 012-3.3c3.64-3.81 7.54-7.78 12.38-8.88a27.76 27.76 0 017-.27 82.24 82.24 0 0012.21-.52c3.34-.39 9-.34 11.82-2.52 2.63-2 4.12-4.55 7.37-5.83a21.57 21.57 0 0110.38-1.11zm12.91 239.76s13.44 26.47 9.37 34.62m15 36.18l-19.68-25v.44s-1.14-8.08 2.61-5.36c8.21 5.94 21.35 15.68 21.63 17.36s-2.66 8.42-4.56 12.56z"
      opacity=".1"
    />
    <path
      d="M179.9 229.76s1.66 6.88-3.71 10.32c8.27-1.42 8.63-7.85 8.38-10.65a26.06 26.06 0 01-4.67.33zM25.15 326.71s74.94-41.54 85.94-62.72c7.89-15.2 26.9-24.31 37-28.25-7.37 2.47-32.17 11.94-41.49 29.88-11 21.18-85.94 62.72-85.94 62.72zm169.33-100.18c12.75-4 24.94-13.87 24.94-13.87l-39.1-27.7.89-3.8-3.74-1.5-1.63 6.92 39.1 27.7a94.35 94.35 0 01-20.46 12.25zm.25 93.86a96.88 96.88 0 0115.33-3.87l.07-.79a103.76 103.76 0 00-15.4 4.66zm-47.39 42.67h-.36a.73.73 0 01-.86-.11 3 3 0 00.86.11c1.34-.78 3.35-6.86-.86-42.06-4.5-37.58-22.16-34.63-31.83-30.31 9.88-2.72 23.48-.37 27.35 31.94 4.21 35.2 2.2 41.29.86 42.06a9 9 0 004.84-1.63zm-4.84 1.64a3 3 0 01-.86-.11.73.73 0 00.86.11z"
      opacity=".1"
    />
    <path
      fill="#a66477"
      d="M170.47 153.97c6.44.73 12.57 3.5 18.91 5a9.34 9.34 0 004.89.19c2.46-.76 4.46-3.34 7-3.26 1.57 0 3 1.12 4.26 2.15a51.11 51.11 0 015.87 5.21c4.37 4.75 7.09 11.15 11.08 16.31s10.28 9.18 15.95 6.81c-3.85 15-16.49 26.47-30.15 27.4-5.45.37-11-.76-16.31.84a14.28 14.28 0 01-4.12 1c-3 0-5.48-2.79-7.38-5.5-4.44-6.38-8-13.62-13-19.43-1.65-1.92-3.6-3.75-5.93-4.1s-4.48.76-6.56 1.84c-3.43 1.78-6.94 3.62-9.6 6.66s-4.34 7.59-3.24 11.71c.59 2.22 1.95 4.22 2 6.55 0 3.7-3.22 6.41-3.87 10a38.6 38.6 0 00-.16 4.56c-.29 4.94-3.51 9-6.89 12.09-1.31 1.21-2.77 2.5-3.15 4.37-.26 1.27 0 2.62-.17 3.91-.49 3.21-3.69 4.83-6.52 5.25a18.9 18.9 0 01-9.78-1.16c4-1.87 6.39-7.2 5.47-12-1.26-6.61-7.9-11.35-7.34-18.09a20.93 20.93 0 011.84-5.95 54.45 54.45 0 003.14-11.28 19.11 19.11 0 00-.19-9c-.85-2.59-2.58-4.65-4.06-6.84a38.82 38.82 0 01-4.7-9.63 6.75 6.75 0 01-.45-3.18 6.59 6.59 0 012-3.3c3.64-3.81 7.54-7.78 12.38-8.88a27.76 27.76 0 017-.27 82.24 82.24 0 0012.21-.52c3.34-.39 9-.34 11.82-2.52 2.63-2 4.12-4.55 7.37-5.83a21.57 21.57 0 0110.38-1.11z"
    />
    <path
      fill="url(#e)"
      d="M958.6 221.09v-.37c0-.12 0-.26-.06-.38h-.16v-.83c-.4-9.27-13.22-29-18.36-23.24-4.5 5.06 2.29 17.86 5.75 23.62l.31.52-.17-.11s-14.31 42.68-16 44.34-13.47 35.22-29 39c-3.07.73-5.62 1.39-7.76 2l.17-.57c1-3.27 2.23-6.36 2.73-10s0-8.05-1.84-9.82c-.9-.88-2-1-2.74-2.4a11.08 11.08 0 01-.76-3.85l-1.32-16.18.92-.28c5.56-1.78 10.95-6 11.58-11.68a6 6 0 01-.59.19 10.13 10.13 0 00.17-1c-4.67 1.84-9-3-13.5-5.17-7.41-3.63-15.88-.21-23.53.62-8.67.95-16.9-2.65-25.76-2-4.82.37-10.18 3.64-9.92 8.39.15 2.61 2 4.82 2.76 7.32 1.92 6.05-2.35 12.12-6.09 17.28-2.46 3.39-4.82 7.52-5.24 11.5-8.61-9-17.92-19.4-19-23.31L776.28 222s-.59.63-1.54 1.56c-.15-.46-.33-1-.53-1.54-3.18-8.91-12.18-30.5-23.59-26.54s4.73 26.09 11.75 34.91l1 1.22a3.16 3.16 0 01-1.78-.08l27.78 47.65s5.05 9.12 9.68 11.6c0 0 34.51 43.51 34.93 52.21s15.52 31.91 15.52 31.91 5.05 37.71-3.79 44.34h1.46c-.42.41-.85.86-1.29 1.35-6.55 7.26-14.92 22.82-3.48 49.28 16.83 39 19.36 54.28 19.36 54.28s-32 1.66-38.3 2.9c-5.58 1.1-27.27 1.87-32.23 2-1.77-2.06-7-6.62-14.06 0-8.84 8.29-15.15 36-15.15 36s-3.37 22.38 8 16.57c0 0 13.47-18.65 17.25-19.48 1.88-.41 3.87-3.18 5.39-5.85l.08.05c.09 0 .46-.2 1.06-.44 2.8-1.11 10.51-3.78 16.59-2.45 3.33.73 17.61.9 32.58.86-3.38 8.1-9.44 29-9.44 29S831 602.8 839.4 602c6-.59 15.2-15.92 20-24.67 3.48-2.55 13.45-11.69 20.82-11l49.66-19.06s11.78-6.63 5.47-28.59c-5-17.46-19.23-53.2-24.85-67.13l-.17-.36c-1.36-3.37-2.18-5.37-2.18-5.37a82.19 82.19 0 01-4.51-19.71c-.05-.53-.09-1.07-.13-1.6a8.84 8.84 0 001.95-1.13s-4.63-46.82 0-51.8l.08-.09v-.06l.08-.1.18-.23.22-.28c.25-.33.55-.74.89-1.24 2.65-3.88 7.59-12.74 6.17-23.2q-.09-.68-.22-1.37a28.57 28.57 0 00-2.88-8.12 22.52 22.52 0 01-.37-3.21v-2.84c0-.47.08-1 .15-1.44v-.18q0-.27.09-.55v-.23c0-.18.08-.36.12-.54v-.19c.06-.24.12-.48.2-.72v-.12q.09-.3.2-.59l.09-.23.2-.48.1-.24c.08-.18.17-.36.26-.54l.07-.15q.18-.33.38-.65l.11-.17.33-.47.16-.21.35-.42.16-.18c.18-.19.36-.38.56-.56 5.47-5 29.88-41.85 29.88-41.85s5.89-8.29 5.89-13.67c.33-.12 10.74-34.82 9.69-45.37zm-65.53 309.75c-.6-5.68-1.2-12.72-1.75-20l9.52 14.84s-.9 4.52-7.77 5.16z"
      transform="translate(-125.1 -119.24)"
    />
    <path
      fill="#493545"
      d="M668.71 408.46s-5.7-9-14.26-.81-14.66 35.43-14.66 35.43-3.26 22 7.74 16.29c0 0 13-18.33 16.7-19.14s7.74-11 7.74-11zm61.09 21.99s-7.74-3.67-10.18-.81S709.03 461 709.03 461s-2.44 18.74 5.7 17.92 22.4-30.16 22.4-30.16z"
    />
    <path
      d="M729.8 430.45s-7.74-3.67-10.18-.81S709.03 461 709.03 461s-2.44 18.74 5.7 17.92 22.4-30.16 22.4-30.16z"
      opacity=".05"
    />
    <path
      fill="#3e3d77"
      d="M756.68 375.06l17.51 27.29s-1.22 6.11-11.81 4.89l-36.25 22.81s-3.15 27.77 6.92 25.25c1.63-.41 13-12.22 21.18-11.4l48.07-18.74s11.4-6.52 5.29-28.1-26.31-71.62-26.31-71.62l-31.93 17.86z"
    />
    <path
      d="M756.68 375.06l17.51 27.29s-1.22 6.11-11.81 4.89l-36.25 22.81s-3.15 27.77 6.92 25.25c1.63-.41 13-12.22 21.18-11.4l48.07-18.74s11.4-6.52 5.29-28.1-26.31-71.62-26.31-71.62l-31.93 17.86z"
      opacity=".05"
    />
    <path
      fill="#3e3d77"
      d="M767.68 415.38c2.44 15.48-11.4 16.7-11.4 16.7s-62.32 1.22-69.65-.41-17.11 2.85-17.11 2.85c-12.63-7.74-2.44-26.88-2.44-26.88s26.07-.81 32.18-2 37.06-2.88 37.06-2.88-2.44-15.07-18.74-53.35c-11.07-26-3-41.3 3.37-48.43a26.82 26.82 0 015.59-4.92l50.1 2.44a65 65 0 00.28 7.57 80.62 80.62 0 006.65 25c-2.85 0-21.18 17.11-21.18 17.11s2.84 51.73 5.29 67.2z"
    />
    <path
      d="M670.74 409.27s26.07-.81 32.18-2 37.06-2.85 37.06-2.85-2.44-15.07-18.74-53.35c-11.07-26-3-41.3 3.37-48.43a26.82 26.82 0 015.59-4.92l46.42 2.26v-1.45l-50.1-2.44a26.82 26.82 0 00-5.59 4.92c-6.34 7.14-14.44 22.43-3.37 48.43 16.34 38.25 18.76 53.32 18.76 53.32s-31 1.63-37.06 2.85-32.18 2-32.18 2-10.18 19.15 2.44 26.92c0 0 .38-.18 1-.44-8.39-8.63.22-24.82.22-24.82z"
      opacity=".1"
    />
    <path
      fill="#493545"
      d="M720.02 146.57h25.25v63.94h-25.25z"
    />
    <path
      d="M720.02 146.57h25.25v63.94h-25.25z"
      opacity=".1"
    />
    <path
      fill="#493545"
      d="M759.71 137.19c.87.24 1.85.27 2.44 1.47a9 9 0 01.59 3l1.59 19.76a11 11 0 00.74 3.78c.67 1.34 1.78 1.5 2.65 2.36 1.75 1.74 2.26 6.1 1.78 9.65s-1.69 6.59-2.64 9.8c-1.36 4.6-2.26 9.77-4.17 13.65s-5.38 6-7.62 2.74-1.94-9.84-2.36-15.23c-.7-9-4.21-16.76-4.45-25.82-.2-7.33 1.77-14.17 3-21.12.88-4.77.93-10.56 2.21-14.85 1.07 5.1 3.11 9.95 6.24 10.81z"
    />
    <path
      d="M759.71 137.19c.87.24 1.85.27 2.44 1.47a9 9 0 01.59 3l1.59 19.76a11 11 0 00.74 3.78c.67 1.34 1.78 1.5 2.65 2.36 1.75 1.74 2.26 6.1 1.78 9.65s-1.69 6.59-2.64 9.8c-1.36 4.6-2.26 9.77-4.17 13.65s-5.38 6-7.62 2.74-1.94-9.84-2.36-15.23c-.7-9-4.21-16.76-4.45-25.82-.2-7.33 1.77-14.17 3-21.12.88-4.77.93-10.56 2.21-14.85 1.07 5.1 3.11 9.95 6.24 10.81z"
      opacity=".1"
    />
    <path
      fill="#c77485"
      d="M652.82 109.1l-9.77 8.15s-1.16-1.36-2.89-3.56c-6.79-8.67-22.4-30.42-11.37-34.31s19.75 17.32 22.83 26.08c.78 2.22 1.2 3.64 1.2 3.64zm176.36-2.85c-4.07 6.11-9.77 0-9.77 0s-.73-1.09-1.76-2.85c-3.35-5.67-9.92-18.24-5.57-23.22 5-5.69 17.39 13.73 17.77 22.84a5.42 5.42 0 01-.67 3.23zm-100.2 65.98s8.15 26.07 5.7 33.8 17.52 16.73 17.52 16.73h22.81s8.15-16.7 6.11-21.59-19.55-8.55-19.55-8.55-10.18 0-9.77-27.29z"
    />
    <path
      d="M652.82 109.1l-9.77 8.15s-1.16-1.36-2.89-3.56c3.55-.63 9.06-5.81 11.47-8.23.77 2.22 1.19 3.64 1.19 3.64zm176.36-2.85c-4.07 6.11-9.77 0-9.77 0s-.73-1.09-1.76-2.85l.13-.41c2.64 1.89 10.85.28 12.07 0a5.42 5.42 0 01-.67 3.26zM776.9 306.06c-12.6 5.75-53.54-4.49-56-5.1a26.82 26.82 0 015.59-4.92l50.1 2.44a65 65 0 00.31 7.58z"
      opacity=".1"
    />
    <path
      fill="#ffaac4"
      d="M734.28 194.63s-9.77 3.26-23.62-9.37c0 0-31-30.55-33-37.88l-24-42s-10.18 11-14.26 9.37l26.88 46.84s4.89 9 9.37 11.4c0 0 33.4 42.77 33.8 51.32s15.05 31.45 15.05 31.45 4.89 37.06-3.67 43.58c0 0 47.65 12.22 57.83 4.07 0 0-4.48-46 0-50.91 0 0 13.85-16.29 4.48-34.21 0 0-2-9.77 3.26-14.66s28.92-41.14 28.92-41.14 5.7-8.15 5.7-13.44c0 0 10.59-35.84 9-45.21 0 0-9.37 2-12.22 0 0 0-13.85 42-15.48 43.58s-13 34.62-28.1 38.29-17.51 5.29-17.51 5.29 29.32 18.33 15.07 26.47-37.5-22.84-37.5-22.84z"
    />
    <path
      d="M752.79 178.5a77.83 77.83 0 01-.59-11.57l-22.81 6.92a30.76 30.76 0 011.43 4.68c2.61 1.15 6.13 3.87 9.16 3.87a20.77 20.77 0 0012.81-3.9z"
      opacity=".1"
    />
    <circle
      cx="739.57"
      cy="160.01"
      r="21.18"
      fill="#c77485"
    />
    <path
      d="M714.37 127.38c-4.66.36-9.86 3.58-9.6 8.25.14 2.57 1.9 4.74 2.67 7.2 1.85 5.95-2.27 11.92-5.89 17s-7 11.81-3.9 17.19a42.39 42.39 0 002.86 3.73c3.83 5.17 3.78 12.15 5.48 18.36a32.21 32.21 0 0037.84 23 20.14 20.14 0 01-4.25-13.62c.23-3.56 1.38-7.28 0-10.57-1.78-4.23-7-5.9-9.69-9.6s-2.51-8.83-1.21-13.24 3.55-8.5 4.63-13a39.16 39.16 0 011-3.89c1.88-5.34 7.5-8.44 13-9.77s11.28-1.41 16.65-3.16 10.59-5.85 11.21-11.48c-4.52 1.81-8.71-2.91-13.07-5.08-7.18-3.56-15.37-.21-22.77.61-8.43.94-16.43-2.55-24.96-1.93z"
      opacity=".1"
    />
    <path
      fill="#493545"
      d="M713.96 126.57c-4.66.36-9.86 3.58-9.6 8.25.14 2.57 1.9 4.74 2.67 7.2 1.85 5.95-2.27 11.92-5.89 17s-7 11.81-3.9 17.19a42.39 42.39 0 002.86 3.73c3.83 5.17 3.78 12.15 5.48 18.36a32.21 32.21 0 0037.84 23 20.14 20.14 0 01-4.25-13.62c.23-3.56 1.38-7.28 0-10.57-1.78-4.23-7-5.9-9.69-9.6s-2.51-8.83-1.21-13.24 3.55-8.5 4.63-13a39.16 39.16 0 011-3.89c1.88-5.34 7.5-8.44 13-9.77s11.28-1.41 16.65-3.16 10.59-5.85 11.21-11.48c-4.52 1.81-8.71-2.91-13.07-5.08-7.18-3.56-15.37-.21-22.77.61-8.41.93-16.38-2.6-24.96-1.93z"
    />
    <path
      d="M760.55 207.06s8.48 7.57 10.15 10.91m8.2 34.3s-10.59 0-15.48 1.22-16.7 0-16.7 0"
      opacity=".1"
    />
    <path
      d="M771.75 217.44a10.18 10.18 0 01-2.93 1.12 11.2 11.2 0 007.82-1.12c14.26-8.15-15.07-26.47-15.07-26.47h-4.89s29.33 18.33 15.07 26.47zm58.34-112.89c0-.26-.06-.51-.1-.74a47.84 47.84 0 01-5.07.77 22.46 22.46 0 005.17-.03zM725.73 299.31c8.55-6.52 3.67-43.58 3.67-43.58s-14.66-22.81-15.07-31.36-33.8-51.32-33.8-51.32c-4.48-2.44-9.37-11.4-9.37-11.4s-27.7-45.21-31.77-46.84l26.88 46.84s4.89 9 9.37 11.4c0 0 33.4 42.77 33.8 51.32s15.06 31.39 15.06 31.39 4.89 37.06-3.67 43.58c0 0 29.29 7.51 46.85 6.83-17.6-.62-41.95-6.86-41.95-6.86zm8.79-104.36l-.24-.31a6.44 6.44 0 01-.85.19c.38.05.74.09 1.09.12z"
      opacity=".1"
    />
    <path
      d="M829.99 103.76l-.25.05c-.43 12.51-9.11 41.9-9.11 41.9 0 5.29-5.7 13.44-5.7 13.44s-23.62 36.25-28.92 41.14-3.26 14.66-3.26 14.66l.05.1c-.16-3.29.24-8.39 3.61-11.51 5.29-4.89 28.92-41.14 28.92-41.14s5.7-8.15 5.7-13.44c0 .06 10.59-35.78 8.96-45.2zm-51.72 145.45c.61 3.46.2-.2.41 3.26 0 0 10-11.73 7.27-26.23.82 12.96-7.68 22.97-7.68 22.97z"
      opacity=".1"
    />
    <ellipse
      cx="469.79"
      cy="620.44"
      class="fill-current text-primary"
      opacity=".1"
      rx="427.67"
      ry="41.08"
    />
    <path
      fill="none"
      stroke="#535461"
      stroke-miterlimit="10"
      stroke-width="2"
      d="M304.01 578.76s-14.56-49.45 2.73-85.84a78.1 78.1 0 006.32-49 131.35 131.35 0 00-6.94-23"
    />
    <use xlink:href="#f" />
    <use
      opacity=".1"
      xlink:href="#f"
    />
    <path
      fill="none"
      stroke="#535461"
      stroke-miterlimit="10"
      stroke-width="2"
      d="M598.65 579.47s-14.56-49.45 2.73-85.84a78.1 78.1 0 006.32-49 131.35 131.35 0 00-6.94-23"
    />
    <use xlink:href="#g" />
    <use
      opacity=".1"
      xlink:href="#g"
    />
    <path
      fill="#dee3f3"
      d="M669.9 15.31h-6.28a4.4 4.4 0 100-8.79H612.7a4.4 4.4 0 000 8.79h6.28a4.4 4.4 0 000 8.79h-8.79a4.4 4.4 0 100 8.79h50.88a4.4 4.4 0 100-8.79h8.83a4.4 4.4 0 000-8.79zM375.68 40.95h-4.78a3.35 3.35 0 100-6.69h-38.72a3.35 3.35 0 000 6.69h4.78a3.35 3.35 0 100 6.69h-6.69a3.35 3.35 0 100 6.69h38.72a3.35 3.35 0 100-6.69h6.69a3.35 3.35 0 000-6.69z"
      opacity=".5"
    />
    <path
      fill="none"
      stroke="#4da5b8"
      stroke-miterlimit="10"
      d="M50.68 514.76s17.5 34.35 3.24 53.14 1.3 70 1.3 70"
    />
    <path
      class="fill-current text-primary"
      d="M55.9 504.02c0 6.62-4.86 12-4.86 12s-4.86-5.37-4.86-12 4.86-12 4.86-12 4.86 5.38 4.86 12z"
    />
    <path
      fill="none"
      stroke="#4da5b8"
      stroke-miterlimit="10"
      d="M59.75 514.76s-17.5 34.35-3.24 53.14-1.3 70-1.3 70"
    />
    <path
      class="fill-current text-primary"
      d="M54.57 504.02c0 6.62 4.86 12 4.86 12s4.86-5.37 4.86-12-4.86-12-4.86-12-4.86 5.38-4.86 12z"
    />
    <path
      d="M54.57 504.02c0 6.62 4.86 12 4.86 12s4.86-5.37 4.86-12-4.86-12-4.86-12-4.86 5.38-4.86 12z"
      opacity=".1"
    />
    <path
      fill="none"
      stroke="#4da5b8"
      stroke-miterlimit="10"
      d="M66.9 514.76s17.5 34.35 3.24 53.14 1.3 70 1.3 70"
    />
    <path
      class="fill-current text-primary"
      d="M72.07 504.02c0 6.62-4.86 12-4.86 12s-4.86-5.37-4.86-12 4.86-12 4.86-12 4.86 5.38 4.86 12zm-2.73 27.52c-4.59 4.77-11.82 5.27-11.82 5.27s.22-7.24 4.81-12 11.82-5.27 11.82-5.27-.25 7.22-4.81 12zm.46 23.7c-4.59 4.77-11.82 5.27-11.82 5.27s.22-7.24 4.81-12 11.82-5.27 11.82-5.27-.22 7.22-4.81 12zm-24.9 13.03c4.34 5 4.19 12.24 4.19 12.24s-7.19-.87-11.53-5.87-4.19-12.24-4.19-12.24 7.19.87 11.53 5.87zm4-50.51c5.52 3.66 7.31 10.68 7.31 10.68s-7.16 1.09-12.68-2.57-7.31-10.68-7.31-10.68 7.19-1.11 12.68 2.57z"
    />
    <path
      d="M48.9 517.76c5.52 3.66 7.31 10.68 7.31 10.68s-7.16 1.09-12.68-2.57-7.31-10.68-7.31-10.68 7.19-1.11 12.68 2.57z"
      opacity=".1"
    />
    <path
      fill="none"
      stroke="#4da5b8"
      stroke-miterlimit="10"
      d="M75.95 514.76s-17.5 34.35-3.24 53.14-1.3 70-1.3 70"
    />
    <path
      class="fill-current text-primary"
      d="M70.77 504.02c0 6.62 4.86 12 4.86 12s4.86-5.37 4.86-12-4.86-12-4.86-12-4.86 5.38-4.86 12z"
    />
    <path
      d="M70.77 504.02c0 6.62 4.86 12 4.86 12s4.86-5.37 4.86-12-4.86-12-4.86-12-4.86 5.38-4.86 12z"
      opacity=".1"
    />
    <path
      class="fill-current text-primary"
      d="M72.17 532.05c-4.65 4.72-5 12-5 12s7.23-.41 11.88-5.13 5-12 5-12-7.23.41-11.88 5.13z"
    />
    <path
      d="M72.17 532.05c-4.65 4.72-5 12-5 12s7.23-.41 11.88-5.13 5-12 5-12-7.23.41-11.88 5.13z"
      opacity=".1"
    />
    <path
      class="fill-current text-primary"
      d="M81.28 564.86c-4.65 4.72-5 12-5 12s7.23-.41 11.88-5.13 5-12 5-12-7.26.41-11.88 5.13z"
    />
    <path
      fill="none"
      stroke="#4da5b8"
      stroke-miterlimit="10"
      d="M67.9 557.65s10.53-16.6 25.32-17m-33.55 6.97s-10.53-16.6-25.32-17m23.95 40.7s10.53-16.6 25.32-17"
    />
    <circle
      cx="92.71"
      cy="540.56"
      r="2.73"
      class="fill-current text-primary"
    />
    <circle
      cx="34.61"
      cy="530.76"
      r="2.73"
      class="fill-current text-primary"
    />
    <path
      fill="none"
      stroke="#4da5b8"
      stroke-miterlimit="10"
      d="M66.05 576.76s-10.53-16.6-25.32-17"
    />
    <circle
      cx="40.99"
      cy="559.92"
      r="2.73"
      class="fill-current text-primary"
    />
    <circle
      cx="83.82"
      cy="554.46"
      r="2.73"
      class="fill-current text-primary"
    />
    <path
      fill="#a8a8a8"
      d="M124.28 617.91s-25.38-5.08-32.16-11.85-37.22-18.61-40.61-10.15-45.69 37.23-16.92 42.31 67.69 6.77 76.15 3.38 13.54-23.69 13.54-23.69z"
    />
    <path
      d="M34.59 635.07c28.77 5.08 67.69 6.77 76.15 3.38 6.44-2.58 10.92-15 12.69-20.72l.85.18s-5.08 20.31-13.54 23.69-47.38 1.69-76.15-3.38c-8.3-1.47-10.68-4.91-9.78-9.26.7 2.8 3.6 5.02 9.78 6.11z"
      opacity=".2"
    />
    <path
      class="fill-current text-primary"
      d="M894.83 522.54s8.38 11-3.87 27.5-22.35 30.51-18.26 40.83c0 0 18.48-30.73 33.52-31.16s5.16-18.7-11.39-37.17z"
    />
    <path
      d="M894.83 522.54a13.57 13.57 0 011.71 3.44c14.68 17.24 22.49 33.33 8.39 33.74-13.14.38-28.9 23.87-32.68 29.81a12.74 12.74 0 00.45 1.35s18.48-30.73 33.52-31.16 5.16-18.71-11.39-37.18z"
      opacity=".1"
    />
    <path
      fill="#ffd037"
      d="M910.41 536.5c0 3.86-.43 7-1 7s-1-3.13-1-7 .54-2 1.07-2 .93-1.85.93 2z"
    />
    <path
      fill="#ffd037"
      d="M915.76 541.11c-3.39 1.85-6.34 3-6.59 2.49s2.28-2.35 5.67-4.19 2.05-.5 2.31 0 1.99-.15-1.39 1.7z"
    />
    <path
      class="fill-current text-primary"
      d="M850.57 522.54s-8.38 11 3.87 27.5 22.35 30.51 18.26 40.83c0 0-18.48-30.73-33.52-31.16s-5.16-18.7 11.39-37.17z"
    />
    <path
      d="M850.57 522.54a13.57 13.57 0 00-1.71 3.44c-14.68 17.24-22.49 33.33-8.39 33.74 13.14.38 28.9 23.87 32.68 29.81a12.74 12.74 0 01-.45 1.35s-18.48-30.73-33.52-31.16-5.16-18.71 11.39-37.18z"
      opacity=".1"
    />
    <path
      fill="#ffd037"
      d="M834.99 536.5c0 3.86.43 7 1 7s1-3.13 1-7-.54-2-1.07-2-.93-1.85-.93 2z"
    />
    <path
      fill="#ffd037"
      d="M829.64 541.11c3.39 1.85 6.34 3 6.59 2.49s-2.28-2.35-5.67-4.19-2.05-.5-2.31 0-2-.15 1.39 1.7z"
    />
    <path
      fill="#a8a8a8"
      d="M837.66 589.43s23.43-.72 30.49-5.75 36-11 37.79-3 35.21 40.11 8.76 40.32-61.46-4.12-68.51-8.41-8.53-23.16-8.53-23.16z"
    />
    <path
      d="M915.17 618.23c-26.45.21-61.46-4.12-68.51-8.41-5.37-3.27-7.51-15-8.22-20.41h-.78s1.48 18.9 8.53 23.19 42.06 8.63 68.51 8.41c7.64-.06 10.27-2.78 10.13-6.8-1.06 2.45-3.93 3.97-9.66 4.02z"
      opacity=".2"
    />
    <path
      fill="#dee3f3"
      d="M177.84 74.64h-6.28a4.4 4.4 0 100-8.79h-50.88a4.4 4.4 0 000 8.79h6.28a4.4 4.4 0 000 8.79h-8.79a4.4 4.4 0 000 8.79h50.88a4.4 4.4 0 100-8.79h8.79a4.4 4.4 0 000-8.79z"
      opacity=".5"
    />
  </svg>
</template>
